(function initFaqsSection() {
  const ICONS = {
    pause: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>',
    play: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M8 5.14v14l11-7-11-7z"/></svg>',
    soundOff: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>',
    soundOn: '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>'
  };

  function videoPlayerMarkup(src) {
    return `<div class="faq-video-player">
      <video class="faq-featured-media__video" src="${src}" autoplay muted loop playsinline preload="auto"></video>
      <div class="faq-video-controls">
        <button class="faq-video-btn js-faq-play-btn is-playing" aria-label="Pause video" type="button">
          <span class="faq-video-btn__icon faq-video-btn__icon--pause">${ICONS.pause}</span>
          <span class="faq-video-btn__icon faq-video-btn__icon--play">${ICONS.play}</span>
        </button>
        <button class="faq-video-btn js-faq-sound-btn is-muted" aria-label="Unmute video" type="button">
          <span class="faq-video-btn__icon faq-video-btn__icon--sound-off">${ICONS.soundOff}</span>
          <span class="faq-video-btn__icon faq-video-btn__icon--sound-on">${ICONS.soundOn}</span>
        </button>
      </div>
    </div>`;
  }

  function initVideoControls(container) {
    const video = container.querySelector('.faq-featured-media__video');
    if (!video) return;

    video.play().catch(() => {});

    const playBtn = container.querySelector('.js-faq-play-btn');
    const soundBtn = container.querySelector('.js-faq-sound-btn');

    if (playBtn) {
      playBtn.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.classList.add('is-playing');
        } else {
          video.pause();
          playBtn.classList.remove('is-playing');
        }
      });
      video.addEventListener('play', () => playBtn.classList.add('is-playing'));
      video.addEventListener('pause', () => playBtn.classList.remove('is-playing'));
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', () => {
        video.muted = !video.muted;
        soundBtn.classList.toggle('is-muted', video.muted);
        soundBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('.section-faqs');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var items = Array.prototype.slice.call(section.querySelectorAll('details.faq-item'));
      if (!items.length) return;

      items.forEach(function (item) {
        var summary = item.querySelector('summary');
        var body = item.querySelector('.faq-item__body');
        if (!summary || !body) return;

        function onToggle(event) {
          event.preventDefault();
          if (item.dataset.animating === 'true') return;

          if (item.hasAttribute('open')) {
            collapseItem(item, section);
          } else {
            var opened = false;
            items.forEach(function (other) {
              if (other !== item && other.hasAttribute('open')) {
                collapseItem(other, section, true);
                opened = true;
              }
            });
            expandItem(item, section, opened);
          }
        }

        summary.addEventListener('click', onToggle);
        summary.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onToggle(event);
          }
        });

        if (item.hasAttribute('open')) {
          body.style.height = 'auto';
        }
      });

      updateFeaturedMedia(section, section.querySelector('details.faq-item[open]'));
      const initialInner = section.querySelector('.faq-featured-media__inner');
      if (initialInner) initVideoControls(initialInner);
    });
  }

  function expandItem(item, section, hadOtherOpen) {
    var body = item.querySelector('.faq-item__body');
    if (!body) return;
    item.dataset.animating = 'true';
    item.setAttribute('open', 'true');
    body.style.height = '0px';
    body.style.opacity = '';
    body.style.marginTop = '';

    updateFeaturedMedia(section, item);

    requestAnimationFrame(function () {
      body.style.height = body.scrollHeight + 'px';
    });

    var onTransitionEnd = function (event) {
      if (event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onTransitionEnd);
      body.style.height = 'auto';
      body.style.opacity = '';
      body.style.marginTop = '';
      delete item.dataset.animating;
    };

    body.addEventListener('transitionend', onTransitionEnd);
  }

  function collapseItem(item, section, skipMediaUpdate) {
    var body = item.querySelector('.faq-item__body');
    if (!body) return;
    item.dataset.animating = 'true';
    body.style.height = body.scrollHeight + 'px';
    body.style.opacity = '0';
    body.style.marginTop = '0';

    requestAnimationFrame(function () {
      body.style.height = '0px';
    });

    var onTransitionEnd = function (event) {
      if (event.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onTransitionEnd);
      item.removeAttribute('open');
      body.style.height = '';
      body.style.opacity = '';
      body.style.marginTop = '';
      delete item.dataset.animating;
      if (!skipMediaUpdate) {
        var nextOpen = section.querySelector('details.faq-item[open]');
        if (nextOpen) {
          updateFeaturedMedia(section, nextOpen);
        }
      }
    };

    body.addEventListener('transitionend', onTransitionEnd);
  }

  function updateFeaturedMedia(section, sourceItem) {
    var mediaWrapper = section.querySelector('.faq-featured-media');
    if (!mediaWrapper) return;

    var type = '';
    var imageSrc = '';
    var videoSrc = '';

    if (sourceItem) {
      type = sourceItem.dataset.mediaType || '';
      imageSrc = sourceItem.dataset.mediaImage || '';
      videoSrc = sourceItem.dataset.mediaVideo || '';
    }

    if (!type || type === 'none' || (type === 'image' && !imageSrc) || (type === 'video' && !videoSrc)) {
      type = mediaWrapper.dataset.defaultType || '';
      imageSrc = mediaWrapper.dataset.defaultImage || '';
      videoSrc = mediaWrapper.dataset.defaultVideo || '';
    }

    var inner = mediaWrapper.querySelector('.faq-featured-media__inner');
    if (!inner) {
      inner = document.createElement('div');
      inner.className = 'faq-featured-media__inner';
      mediaWrapper.appendChild(inner);
    }

    var currentType = mediaWrapper.dataset.currentType || '';
    var currentImage = mediaWrapper.dataset.currentImage || '';
    var currentVideo = mediaWrapper.dataset.currentVideo || '';

    if (
      currentType === (type || '') &&
      currentImage === (imageSrc || '') &&
      currentVideo === (videoSrc || '')
    ) {
      return;
    }

    mediaWrapper.dataset.currentType = type || '';
    mediaWrapper.dataset.currentImage = imageSrc || '';
    mediaWrapper.dataset.currentVideo = videoSrc || '';

    function swapMedia(markup) {
      inner.classList.add('is-fading');
      setTimeout(function () {
        inner.innerHTML = markup;
        inner.offsetHeight;
        inner.classList.remove('is-fading');
        initVideoControls(inner);
      }, 120);
    }

    if (type === 'video' && videoSrc) {
      swapMedia(videoPlayerMarkup(videoSrc));
    } else if (imageSrc) {
      var preloadImg = new Image();
      preloadImg.onload = function () {
        swapMedia('<img src="' + imageSrc + '" alt="" loading="eager">');
      };
      preloadImg.onerror = function () {
        swapMedia('<img src="' + imageSrc + '" alt="" loading="eager">');
      };
      preloadImg.src = imageSrc;
    } else {
      swapMedia('<div class="faq-featured-media__placeholder body-s">Add media to this FAQ</div>');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Theme Editor events — re-init FAQ accordion on section re-render
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector
      ? e.target.querySelector('.section-faqs')
      : null;
    if (!section && e.target.classList && e.target.classList.contains('section-faqs')) {
      section = e.target;
    }
    if (section) init();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var faqItem = e.target.closest('details.faq-item');
    if (!faqItem) return;
    // Open the selected block's FAQ item if not already open
    if (!faqItem.hasAttribute('open')) {
      var summary = faqItem.querySelector('summary');
      if (summary) summary.click();
    }
    // Scroll into view
    faqItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
})();
